import {
  DocumentOrganizationKeys,
  FilterDocument,
} from 'shared/types/filter-document';
import { Tag } from 'shared/types/tag';

import { getDefaultFilterDocument } from './get-default-filter-document';

export const getFilterDocument = (tag?: Tag): FilterDocument => {
  const base = getDefaultFilterDocument(tag);

  return {
    ...base,
    ...(tag?.filterDocument ?? {}),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(tag?.filterDocument?.filters ?? {}),
    },
  };
};
